import React from "react";
import { CheckIcon } from "lucide-react";
import { CtaButton } from "./CtaButton";
import { PaymentLogos } from "./PaymentLogos";
import { images, price } from "../data/content";
export type OfferHighlight = {
  bold: string;
  rest?: string;
};
type OfferCardProps = {
  title: string;
  highlights: OfferHighlight[];
};
export function OfferCard({
  title,
  highlights
}: OfferCardProps) {
  return <div className="grid items-center gap-8 rounded-2xl bg-white p-6 shadow-sm md:grid-cols-[1fr_1.05fr] md:p-10" data-id="element-166" data-mp="1j8w82z7j2mac">
      <img src={images.productBox} alt="The complete Woodworking Ready collection" className="w-full" data-id="element-167" data-mp="1f7u4k66kvo2k" />
      <div data-id="element-168" data-mp="1aerkconoxqz1">
        <h3 className="text-center font-heading text-2xl font-bold uppercase leading-tight text-brand md:text-4xl" data-id="element-169" data-mp="1aehtkyutnfsa">{title}</h3>
        <ul className="mt-8 space-y-4" data-id="element-170" data-mp="15f55kas7s2o4">
          {highlights.map(h => <li key={h.bold} className="flex items-start gap-3 text-base leading-relaxed" data-id="element-171" data-mp="22xoeofziiyj4">
              <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-brand" aria-hidden="true" data-id="element-172" data-mp="1y42ehnajcn47">
                <CheckIcon className="h-3.5 w-3.5 text-white" strokeWidth={3} data-id="element-173" data-mp="8i5o19kdaea3" />
              </span>
              <span data-id="element-174" data-mp="dgqptdf9p60n">
                <strong className="font-heading font-bold" data-id="element-175" data-mp="3vtezrwr0lrp4">{h.bold}</strong>
                {h.rest && <span className="text-ink-muted" data-id="element-176" data-mp="3ounfq65etqm"> {h.rest}</span>}
              </span>
            </li>)}
        </ul>
        <p className="mt-8 flex flex-wrap items-baseline justify-center gap-3" data-id="element-177" data-mp="3lufyx0chr0co">
          <span className="font-heading text-5xl font-bold text-brand" data-id="element-178" data-mp="3qtit1pqxnm5v">{price.current}</span>
          <span className="font-heading text-2xl text-ink line-through" data-id="element-179" data-mp="3cuasasf4g5zk">{price.original}</span>
        </p>
        <div className="mt-5" data-id="element-180" data-mp="3gv33hr7k0kyh">
          <CtaButton size="lg" label="Add to cart" caption="Instant Digital Download" data-id="element-181" data-mp="3gwe6hot6dooj" />
        </div>
        <div className="mt-4 flex justify-center" data-id="element-182" data-mp="1b3zchbr08l48">
          <PaymentLogos centered data-id="element-183" data-mp="1f49mczhx3vod" />
        </div>
      </div>
    </div>;
}